import { Add, ListAlt, PrivacyTip } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { modalDocumentGroup, modalNewAdmission, permissionsAtom } from "../../atoms/atom";
import AppBar from "../../components/app-bar/AppBar";
import NewAdmissionModal from "../../components/audit/new-admission-modal/NewAdmissionModal";
import CreateGroupModal from "../../components/documents/create-group-modal/CreateGroupModal";
import { AuditService } from "../../services/AuditService";
import { DocumentsGroupDTO } from "../../types/DocumentsGroupDTO";
import { useUtils } from "../../utils/utilFunctions";
import { getLoading } from "../execution-events/ExecutionEvents";
import { obtemIconeOrdem } from "../executions/Executions";
import './AuditManagement.scss';

const AuditManagement: FC = () => {
	const [openCreate, setOpenCreate] = useAtom(modalDocumentGroup);
	const [permissions] = useAtom(permissionsAtom);
	const [, setOpen] = useAtom(modalNewAdmission);
	const [search, setSearch] = useState('');
	const [ordemAsc, setOrdemAsc] = useState(false);
	const [fieldOrder, setFieldOrder] = useState<'NAME'>('NAME');
	const [groups, setGroups] = useState<DocumentsGroupDTO[]>([]);
	const [loading, setLoading] = useState(true);
	const [groupEdit, setGroupEdit] = useState(0);
	const navigate = useNavigate();
	const { verifyPermission } = useUtils();
	const service = new AuditService();

	function mudaOrdem(field: 'NAME') {
		setFieldOrder(field);
		setOrdemAsc(!ordemAsc);
	}

	const handleClickLink = (v: number) => {
		setGroupEdit(v);
		setOpen(true);
	}

	useEffect(() => {
		if (openCreate) return;
		const loadGroups = async () => {
			const response = await service.getGroups();
			if (response) {
				setGroups(response.data);
			}
			setLoading(false);
		};
		loadGroups();
	}, [openCreate]);

	useEffect(() => {
		if (!!permissions.length) {
			verifyPermission(permissions, 'AUDIT');
		}
	}, []);

	return (
		<>
			<AppBar
				modulo="Auditoria de admissões"
			/>
			<div className="audit-management">
				<div className="top">
					{!permissions.includes('ADD_AUDIT_COMPANY')
						? <></>
						: <Button
							variant="contained"
							color="info"
							startIcon={<Add />}
							onClick={() => setOpenCreate(true)}
						>
							Adicionar empresa
						</Button>
					}
					<TextField
						label="Buscar empresa pelo nome"
						id="group-search"
						size="small"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
					/>
				</div>
				{loading
					? getLoading()
					: <div className="tabela">
					<div className="header-tabela">
						<p onClick={() => mudaOrdem('NAME')} id="sort">Empresa {obtemIconeOrdem('NAME', fieldOrder, ordemAsc)}</p>
					</div>
					<div className="body-table">
						{filter().map((group) => (
							<div id={group.companyNameGroup + ''} className="linha-empresa">
								<p>
									{group.companyNameGroup}
								</p>
								<Button
									onClick={() => handleClickLink(group.companyIdGroup)}
									variant='contained'
									color='success'
									startIcon={<Add />}
								>
									Gerar link de admissão
								</Button>
								{!permissions.includes('LGPD_POLICY_CONFIG')
									? <></>
									: <Button
										variant="contained"
										color="secondary"
										startIcon={<PrivacyTip />}
										onClick={() => navigate(`/auditoria/${group.companyIdGroup}/lgpd`)}
									>
										Configurações & LGPD
									</Button>
								}
								<Button
									onClick={() => navigate(`/auditoria/${group.companyIdGroup}/admissoes`)}
									variant='contained'
									startIcon={<ListAlt />}
								>
									Visualizar admissões
								</Button>
							</div>
						))}
					</div>
				</div>}
			</div>
			<CreateGroupModal
				create={(cnpj) => service.createGroup(cnpj)}
				cnpjs={groups.map(group => group.cnpj)}
			/>
			<NewAdmissionModal
				id={groupEdit}
			/>
		</>
	);

	function filter() {
		let filtered = [...groups];
		if (search) {
			filtered = filtered.filter(item => item.companyNameGroup.toLowerCase().includes(search.toLowerCase()));
		}
		return filtered.sort((a, b) => {
			let valueA: string | number;
			let valueB: string | number;
			switch (fieldOrder) {
				default:
					valueA = a.companyNameGroup;
					valueB = b.companyNameGroup;
			}
			return ordemAsc
				? valueA.localeCompare(valueB)
				: valueB.localeCompare(valueA);
		});
	}
};

export default AuditManagement;